import React from 'react';
import {Clients, Services, Wait, Community, Motivate, National, Paper, Risks, Goals, Inform, Standardize, Mobilize, Thumbs, Editing, Experience, Profitable, RightTime, Sales, Timesaver, Guide, Region, Welcome} from '../../../../../../components/svgs/advantages';
import {colors} from '../../../../../../style/constants';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: 105,
    [theme.breakpoints.down('md')]: {
      height: 75,
    },
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },
    marginBottom: 30,
    '& > *': {
      height: '100%'
    },
    '& svg': {
      width: 'auto',
      height: '100%',
      maxHeight: 60,
      paddingRight: 30,
      marginLeft: 'auto',
      [theme.breakpoints.down('xs')]: {
        paddingRight: 15,
      },
      boxSizing: 'border-box',
    },
    '& .active': {
      borderColor: colors.TURQUOISE,
    },
  },
  infos: {
    height: '100%',
    padding: '0px 15px 0 30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 20,
    },
    borderLeft: 'grey 5px solid',
    borderColor: colors.GREY,
    boxSizing: 'border-box',
  },
}));

const Advantage = (props) => {

  const renderIcon = () => {
    if(props.item.icon === 'clients'){
      return <Clients />
    }
    if(props.item.icon === 'services'){
        return <Services />
    }
    if(props.item.icon === 'wait'){
      return <Wait />
    }
    if(props.item.icon === 'community'){
        return <Community />
    }
    if(props.item.icon === 'motivate'){
      return <Motivate />
    }
    if(props.item.icon === 'national'){
        return <National />
    }
    if(props.item.icon === 'paper'){
      return <Paper />
    }
    if(props.item.icon === 'risks'){
      return <Risks />
    }
    if(props.item.icon === 'goals'){
      return <Goals />
    }
    if(props.item.icon === 'inform'){
        return <Inform />
    }
    if(props.item.icon === 'standardize'){
      return <Standardize />
    }
    if(props.item.icon === 'mobilize'){
      return <Mobilize />
    }
    if(props.item.icon === 'thumbs'){
      return <Thumbs />
    }
    if(props.item.icon === 'editing'){
      return <Editing />
    }
    if(props.item.icon === 'experience'){
      return <Experience />
    }
    if(props.item.icon === 'profitable'){
        return <Profitable />
    }
    if(props.item.icon === 'right-time'){
      return <RightTime />
    }
    if(props.item.icon === 'sales'){
      return <Sales />
    }
    if(props.item.icon === 'timesaver'){
      return <Timesaver />
    }
    if(props.item.icon === 'guide'){
      return <Guide />
    }
    if(props.item.icon === 'region'){
      return <Region />
    }
    if(props.item.icon === 'welcome'){
      return <Welcome />
    }
  }

  const classes = useStyles();
  return(
    <Grid className={classes.wrapper} container justifyContent='center' alignItems='center' onMouseEnter={props.onMouseEnter}>
      <Grid item container alignItems='center' xs={2}>
      {renderIcon()}
      </Grid>
      <Grid item container alignItems='center' xs={10}>
      <Grid container direction='column' justifyContent='center' className={classes.infos + ' ' + props.className}>
        <h4>{props.item.title}</h4>
        <h5>{props.item.description}</h5>
      </Grid>
      </Grid>
    </Grid>
  )
}

export default Advantage;